import { useSeenApi } from '#src/contexts/seen-api/useSeenApi.ts'
import { useAIAssistantStore } from '#src/hooks/useAIAssistantStore.ts'
import { useCurrentPractitionerPerms } from '#src/hooks/useCurrentPractitionerPerms.ts'

export function useIsFloatingAssistantVisible(): boolean {
  const { aiEnabled } = useSeenApi()
  const { isAuditor } = useCurrentPractitionerPerms()
  const assistantOpen = useAIAssistantStore((s) => s.open)
  const patientId = useAIAssistantStore((s) => s.patientId)

  return aiEnabled && !isAuditor && !assistantOpen && !!patientId
}
